export const ApiEndpoints = {
    BASE_URL: "/api",
    WS_URL: process.env.REACT_APP_WS_URL,
    GET_MATCHES_CARD: "/matches/card",
    GET_SERVERS: "/matches/servers",
    GET_TEAMS: "/teams",
    GET_LAST_OUTCOME: "/teams/outcome",
    TOP_BATTERS: "/stats/top-batters",
    TOP_BOWLERS: "/stats/top-bowlers",
    TOP_SCORES: "/stats/top-scores",
    HEAD_TO_HEAD: "/stats/head-to-head",
    SESSION_STATS: "/stats/session",
};